// Centralized service catalog
export const SERVICES = [
  {
    id: "exterior",
    label: "Exterior",
    price: "$75",
    duration: "60-90 min",
    description: "Hand wash, wheels & tires, windows, and a hydrophobic spray sealant for that fresh-off-the-lot shine.",
    image: "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxjYXIlMjBleHRlcmlvciUyMGRldGFpbGluZyUyMHdhc2hpbmd8ZW58MHx8fHwxNzgxMDU5NDMwfDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Foam pre-wash & contact wash",
      "Wheels, tires & wheel wells",
      "Windows inside & out",
      "Tire shine + spray sealant",
    ],
  },
  {
    id: "interior",
    label: "Interior",
    price: "$100",
    duration: "90-120 min",
    description: "Complete vacuum, dashboard & console wipe-down, glass, and a streak-free interior reset.",
    image: "https://images.unsplash.com/photo-1732357624591-f2137085659b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxjYXIlMjBpbnRlcmlvciUyMGNsZWFuaW5nJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc4MTA1OTQzMHww&ixlib=rb-4.1.0&q=85",
    features: [
      "Full vacuum (carpets, seats, mats)",
      "Dashboard, console & door panels",
      "Interior glass",
      "Trash removal & light air freshener",
    ],
  },
  {
    id: "full_detail",
    label: "Full Detail (Interior & Exterior)",
    price: "$200",
    duration: "3-4 hrs",
    description: "The works. Inside and out. Showroom finish, ready for date night or resale photos.",
    image: "https://images.unsplash.com/photo-1673166105764-a6aa7e0e73a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXIlMjBzaGlueSUyMGNsZWFuJTIwcGFya2VkfGVufDB8fHx8MTc4MTA1OTQzMHww&ixlib=rb-4.1.0&q=85",
    features: [
      "Everything in Exterior + Interior",
      "Wheels, tires, windows, sealant",
      "Vacuum, dashboard, console, glass",
      "Interior + exterior in one visit",
    ],
  },
];

export const TIME_SLOTS = [
  "8:00 AM",
  "9:30 AM",
  "11:00 AM",
  "12:30 PM",
  "2:00 PM",
  "3:30 PM",
  "5:00 PM",
];

export const GALLERY = [
  {
    type: "video",
    src: "/videos/work1.mp4",
    poster: "/videos/work1-poster.jpg",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_mobile-detail-pro-26/artifacts/k5bs0vz1_IMG_1015.jpeg",
  },
  {
    type: "video",
    src: "/videos/work2.mp4",
    poster: "/videos/work2-poster.jpg",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_mobile-detail-pro-26/artifacts/xgl138u3_IMG_1011.jpeg",
  },
  {
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_mobile-detail-pro-26/artifacts/fma1t4a2_IMG_1013.jpeg",
  },
];

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_mobile-detail-pro-26/artifacts/7gw3n0le_08359B4E-3426-4E1B-A91F-2A44B1D35D37.png";

export const PROMO = {
  enabled: true,
  serviceId: "full_detail",
  promoPrice: "$150",
  regularPrice: "$200",
  text: "First 25 customers: Get your first Full Detail for $150",
  badge: "Save $50",
};

export const CONTACT = {
  phone: "+1-801-940-8558",
  phoneDisplay: "(801) 940-8558",
  email: "dt.detail.2026@gmail.com",
  area: "Northern Utah",
  socials: {
    instagram: {
      handle: "@dt.detail.ut",
      url: "https://instagram.com/dt.detail.ut",
    },
    facebook: {
      handle: "DT Detail",
      url: "https://facebook.com/DTDetail",
    },
  },
};
